import crudHandlers from './_crud';

// const initialState = {
//     campaigns: []
// }

export default (state, action, parseBody) => {
    let { response } = action;

    switch(action.type) {
        case 'SET_CAMPAIGNS':
            return {
                ...state,
                campaigns: action.payload || []
            }
        case 'ADD_AD_CAMPAIGN':{
            const entity_id = response.id || response._id;

            if (parseBody)
                response = parseBody(response)
        
            return {
                ...state,
                entities: {
                ...state.entities,
                [entity_id]: {
                    ...state[entity_id],
                    ...response
                }
                }
        
            };        
        }

        default:{
            state = crudHandlers(state, action, 'ad_campaign');
            return state;            
        }
    }
}
